import { Component, OnInit, Injectable, HostListener } from "@angular/core";
import { FormGroup, FormControl, Validators, NgForm } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../../core/services/authentication.service";
import { Constants } from "../../../../core/services/constants";
import { LoginService } from "../login.service";
import { MatDialog, MatDialogRef } from "@angular/material";
import { ErrorDialogComponent } from "../../error-dialog/error-dialog.component";
import { GeneralService } from "../../../services/general.service";
import { SessionStateService } from "../../../../core/services/session-state.service";
import { PrivacyPolicyDialogComponent } from "../../privacy-policy-dialog/privacy-policy-dialog.component";
import { Observable } from "rxjs";

@Component({
  selector: "app-sign-in",
  templateUrl: "./sign-in.component.html",
  styleUrls: ["./sign-in.component.scss"],
})
@Injectable()
export class SignInComponent implements OnInit {
  seePassword: Boolean;
  signInForm: FormGroup;
  errorMessage: String = "";
  signinError: Boolean = false;
  signinWrongCredError: Boolean = false;
  loading: Boolean = false;
  rememberMe: boolean;
  fileNameDialogRef: MatDialogRef<ErrorDialogComponent>;
  privacyPolicyDialogRef: MatDialogRef<PrivacyPolicyDialogComponent>;
  isMobile = false;
  isWindowsPhone = false;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private loginService: LoginService,
    private dialog: MatDialog,
    private sessionStateService: SessionStateService,
    private generalService: GeneralService
  ) {}

  @HostListener("window:beforeunload", ["$event"])
  beforeUnloadHandler(event) {
    this.sessionStateService.clearSession();
  }

  openErrorDialog(errorMessage: string): void {
    this.fileNameDialogRef = this.dialog.open(ErrorDialogComponent, {
      data: {
        errorMsg: errorMessage,
      },
      autoFocus: false,
      panelClass: "errorPopup",
    });
  }

  openPrivacyPolicyDialog(): void {
    this.privacyPolicyDialogRef = this.dialog.open(
      PrivacyPolicyDialogComponent,
      {
        autoFocus: false,
      }
    );
  }

  ngOnInit() {
    this.signInForm = new FormGroup({
      user: new FormControl(
        "",
        Validators.nullValidator && Validators.required
      ),
      password: new FormControl(
        "",
        Validators.nullValidator && Validators.required
      ),
    });
    this.isMobile = this.generalService.isMobile();
    this.isWindowsPhone = this.generalService.isWindowsPhone();

    if (this.rememberMe === undefined) {
      this.rememberMe = false;
    }
    this.verifyLang();
    if (
      this.authenticationService.isAuthenticated() &&
      this.sessionStateService.getRememberMe()
    ) {
      this.router.navigate(["/"]);
    }
  }

  onSignIn(form: NgForm) {
    this.loading = true;
    this.loginService
      .signIn(form.value.user.trim(), form.value.password)
      .finally(() => {
        this.sessionStateService.setRememberMe(this.rememberMe);
        this.loading = false;
      })
      .subscribe(
        (res) => {
          this.openPrivacyPolicyDialog();
        },
        (err) => {
          this.signinError = true;
          if (err.message === Constants.MSG.LOGIN_WRONG_CREDENTIALS) {
            this.signinWrongCredError = true;
            this.errorMessage = err.message;
          } else if (err.message === Constants.MSG.USER_NOT_FOUND) {
            this.signinWrongCredError = true;
            this.errorMessage = err.message;
          } else {
            this.signinWrongCredError = false;
            this.openErrorDialog(err.message);
          }
        }
      );
  }

  forgotPassword() {
    this.router.navigate(["/forgot"]);
  }

  cleanForm() {
    if (this.signinError) {
      this.signinError = false;
      this.signinWrongCredError = false;
      this.errorMessage = "";
    }
  }

  verifyLang() {
    switch (this.sessionStateService.getLang()) {
      case "EN": {
        this.generalService.useEnglish();
        break;
      }
      case "PT": {
        this.generalService.usePortuguese();
        break;
      }
      case "ES": {
        this.generalService.useSpanish();
        break;
      }
      default: {
        this.generalService.useNavigatorLang();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/login/sign-in/sign-in.component.ts